import { Brand } from "@smartdevis/utils/src/types"

const fileTypes = ["csv", "pdf", "json", "ts"] as const

export type FileType = typeof fileTypes[number]

export type FileName = Brand<string, "filename">

export const toFileName = (v: string, ext: FileType) => `${v}.${ext}` as FileName
